import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/ui/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded border font-mono text-xs font-medium transition-colors",
  {
    variants: {
      variant: {
        default:
          "border-blue-500/30 bg-blue-500/12 px-2 py-0.5 text-blue-400",
        secondary:
          "border-amber-500/30 bg-amber-500/12 px-2 py-0.5 text-amber-300",
        success:
          "border-emerald-500/30 bg-emerald-500/12 px-2 py-0.5 text-emerald-400",
        warning:
          "border-cyan-500/30 bg-cyan-500/12 px-2 py-0.5 text-cyan-400",
        destructive:
          "border-red-500/30 bg-red-500/12 px-2 py-0.5 text-red-400",
        outline:
          "border-border/60 px-2 py-0.5 text-muted-foreground",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
